import {Button, Flex, Form, Input, notification} from "antd";
import React, { createContext, useState } from 'react';
import {useNavigate} from "react-router-dom";
import s from './form.module.scss';
import { RouteNames } from '../../../router/routeNames';
import { EmailInputIcon } from '../../../assets/image/svg';
import { resetPassword } from '../../../store/users';
import { useStoreDispatch } from '../../../store';
import { NotificationPlacement } from 'antd/es/notification/interface';

const Context = createContext({ name: 'Default' });

const ForgetLogin = () => {
    const dispatch = useStoreDispatch()
    const router = useNavigate()
    const [api, contextHolder] = notification.useNotification();
    const [loading, setLoading] = useState<boolean>(false);

    const onFinish = async (data: any) => {
        setLoading(true)
        dispatch(resetPassword(data.email)).then((response: any) => {
            const jRes = JSON.parse(response.payload);
            if (jRes.success === 0) {
                ///openNotification('topRight',jRes.message);
                setLoading(false)
            } else {
                setLoading(false)
                router(RouteNames.LOGIN, { state: { param: jRes } });
            }
        })
    }

    const clickLogin = () => {
        router(RouteNames.LOGIN)
    }
    return (
        <>
            {contextHolder}
            <Flex align={'center'} justify={"center"} vertical>
                <h1>Забыли пароль?</h1>
                <Form onFinish={onFinish} layout="vertical" style={{width: '100%'}}>
                    <Form.Item
                        name="email"
                        className={s.smallStep}
                        rules={[{
                            type: 'email', message: 'Введенный адрес электронной почты неверен!'
                        },
                            {
                                required: true, message: 'Пожалуйста, введите свой адрес электронной почты!'
                            }]}
                    >
                        <Input placeholder="e-mail" prefix={<EmailInputIcon/>}/>
                    </Form.Item>
                    <Form.Item name="button" className={s.bigStep}>
                        <Flex align={'center'} vertical gap={20}>
                            <Button type="primary" block htmlType="submit" loading={loading}>
                                Отправить ссылку
                            </Button>
                            <p onClick={clickLogin} className={s.ahref}>или войдите</p>
                        </Flex>
                    </Form.Item>
                </Form>
            </Flex>
        </>
    );
};

export default ForgetLogin;
